import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Spinner,
  Badge,
  Button,
} from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { useSelector, useDispatch } from "react-redux"

//i18n
import { withTranslation } from "react-i18next"
import axios from "axios"
import { Link } from "react-router-dom"
import { connect } from "formik"
import { use } from "i18next"
import { TOGGLE_LEFTMENU } from "store/layout/actionTypes"
import apiURl from "url"
import { faL } from "@fortawesome/free-solid-svg-icons"
import DatePicker from "react-datepicker"
import { messaging, getToken, onMessage } from "./firebase"

function formatAmountCurrency(amount, currency) {
  return amount.toLocaleString("en-US", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 2,
  })
}

const Dashboard = props => {
  const role = localStorage.getItem("role")
  const user_id = localStorage.getItem("login_user_id")
  const full_name = localStorage.getItem("full_name")
  const assigned_users =
    JSON.parse(localStorage.getItem("assigned_users")) || []
  const [loading1, setLoading1] = useState(false)
  const [loading, setLoading] = useState(false)

  const [showForm, setShowForm] = useState(false)
  const [parcelCounts, setParcelCounts] = useState({
    allParcel: "0",
    newParcelCount: "0",
    inProgressParcelCount: "0",
    deliveredParcelCount: "0",
  })
  const [requestCounts, setRequestCounts] = useState({
    allRequest: "0",
    todayDateRequest: "0",
    newRequest: "0",
    approvedRequest: "0",
    declineRequest: "0",
    resubmitRequest: "0",
  })

  const [todayParcel, setTodayParcel] = useState(0)

  const [OrderData, setOrderData] = useState([])
  const [totalRevenue, setTotalRevenue] = useState([])
  const [todayRevenue, setTodayRevenue] = useState([])
  const [todayDate, setTodayDate] = useState([])

  // Add state for date range
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const requestPermission = async () => {
    try {
      const currentToken = await getToken(messaging, {
        vapidKey:
          "BIoC9ksa59UzKjWKu-ucn03DNKv1NQiD6XVe9gk1AVpNLDBrFho8SNQT9UORcmu7MUSM11Rq0jwP_wDCftbiHkM",
      })
      if (currentToken) {
        // console.log("FCM Token:", currentToken)
        // Save this token to your database/server for push notifications
      } else {
        console.log(
          "No registration token available. Request permission to generate one."
        )
      }
    } catch (error) {
      console.error("An error occurred while retrieving token. ", error)
    }
  }

  const listenForMessages = () => {
    onMessage(messaging, payload => {
      console.log("Message received. ", payload)
      // Customize notification UI or state update here
      alert(payload.notification.title + ": " + payload.notification.body)
    })
  }
  useEffect(() => {
    requestPermission()
    listenForMessages()
  }, [])
  // Function to filter OrderData by date range
  const filterDataByDateRange = (data, startDate, endDate) => {
    if (!startDate && !endDate) return data
    return data.filter(item => {
      const createdDate = new Date(item.created_date)
      if (startDate && endDate) {
        return createdDate >= startDate && createdDate <= endDate
      }
      if (startDate) return createdDate >= startDate
      if (endDate) return createdDate <= endDate
      return true
    })
  }

  //Cvi Amount
  const [totalCviAmount, SetTotalCviAmount] = useState([])
  const [gstAmount, setGstAmount] = useState([])
  //Document Charges Amount
  const [DocumentChargesAmount, setDocumentChargesAmount] = useState([])
  //Count All Parcel
  const fetchParcelCounts = () => {
    const data = {
      Role: role,
      User_id: user_id,
      assigned_users: assigned_users,
    }
    const URL = `${apiURl}/countParcelsByStatus`
    axios
      .post(URL, data)
      .then(response => {
        if (response.data.status === "success") {
          const {
            total_parcel_count,
            new_parcel_count,
            in_progress_parcel_count,
            delivered_parcel_count,
          } = response.data.parcelCounts
          setParcelCounts({
            allParcel: total_parcel_count || "0",
            newParcelCount: new_parcel_count || "0",
            inProgressParcelCount: in_progress_parcel_count || "0",
            deliveredParcelCount: delivered_parcel_count || "0",
          })
        } else {
          console.error("Failed to fetch parcel counts:", response.data.message)
        }
      })
      .catch(error => {
        console.error("Error fetching parcel counts:", error)
      })
  }
  //Count Today Parcel
  const fetchTodayParcelCounts = () => {
    const data = {
      Role: role,
      User_id: user_id,
      assigned_users: assigned_users,
    }
    const URL = `${apiURl}/countParcelsForToday`
    axios
      .post(URL, data)
      .then(response => {
        if (response.data.status === "success") {
          const count = response.data.parcelCountForToday
          if (count) {
            setTodayParcel(count.total_parcel_count_for_today)
          } else {
            setTodayParcel(0)
          }
        } else {
          console.error("Failed to fetch parcel counts:", response.data.message)
        }
      })
      .catch(error => {
        console.error("Error fetching parcel counts:", error)
      })
  }

  //Count Requests
  const fetchRequestCounts = () => {
    const data = {
      Role: role,
      User_id: user_id,
      assigned_users: assigned_users,
    }
    const URL = `${apiURl}/countRequestByStatus`
    axios
      .post(URL, data)
      .then(response => {
        if (response.data.status === "success") {
          const {
            total_request_count,
            new_count,
            approved_count,
            declined_count,
            resubmit_count,
            today_request_count,
          } = response.data.requestCounts

          setRequestCounts({
            allRequest: total_request_count || "0",
            todayDateRequest: today_request_count || "0",
            newRequest: new_count || "0",
            approvedRequest: approved_count || "0",
            declineRequest: declined_count || "0",
            resubmitRequest: resubmit_count || "0",
          })
        } else {
          console.error("Failed to fetch parcel counts:", response.data.message)
        }
      })
      .catch(error => {
        console.error("Error fetching parcel counts:", error)
      })
  }

  //Fetch All Parcel Data
  const fetchParcelinfo = (Role, User_id) => {
    setLoading(true)
    const data = {
      role: Role,
      user_id: User_id,
      assigned_users: assigned_users,
    }
    const URL = `${apiURl}/fetchParcelDetails`
    axios
      .post(URL, data)
      .then(response => {
        if (response.data.status === "success") {
          setLoading(false)
          setOrderData(response.data.parcelDetails)
        } else {
          setLoading(false)
          console.error("Failed to fetch users:", response.data.message)
        }
      })
      .catch(error => {
        setLoading(false)
        console.error("Error fetching users:", error)
      })
  }

  //ToDay Date
  const date = () => {
    // Fetch current date from the server
    axios
      .get(`${apiURl}/currentDate`)
      .then(response => {
        const currentDate = response.data.currentDate
        setTodayDate(currentDate)
      })
      .catch(error => {
        console.error("Error fetching current date:", error)
      })
  }

  //For Total Revenue
  useEffect(() => {
    let TotalParcelAmount = 0
    let TotalDocAmount = 0
    let ParcelCviAmount = 0
    let DocCviAmount = 0
    let DocumnetChargesAmount = 0
    let riderCharges = 0

    const filteredData = filterDataByDateRange(OrderData, startDate, endDate)

    filteredData.forEach(item => {
      const Parcelamount = parseFloat(item.total_price) || 0
      const Docamount = parseFloat(item.docs_total_price) || 0
      const Pcviamount = parseFloat(item.parcel_price) || 0
      const Dcviamount = parseFloat(item.doc_cvi_amount) || 0
      const DocChargesAmount = parseFloat(item.dep_charges_amount) || 0
      const riderChargesAmount =
        item.rider_charges && parseFloat(item.rider_charges) > 0
          ? parseFloat(item.rider_charges)
          : 0

      TotalParcelAmount += Parcelamount
      TotalDocAmount += Docamount
      ParcelCviAmount += Pcviamount
      DocCviAmount += Dcviamount
      DocumnetChargesAmount += DocChargesAmount
      riderCharges += riderChargesAmount
    })

    const TotalAmount = TotalParcelAmount + TotalDocAmount
    const TotalCviAmount = ParcelCviAmount + DocCviAmount
    const CviPercent = TotalCviAmount * 0.025
    const ForGST = TotalAmount - CviPercent - riderCharges
    const GSTAmount = ForGST * 0.15
    const TotalAmountWithGST = TotalAmount + GSTAmount
    setGstAmount(GSTAmount)
    setDocumentChargesAmount(DocumnetChargesAmount)
    setTotalRevenue(TotalAmountWithGST)
    SetTotalCviAmount(TotalCviAmount)
  }, [OrderData, startDate, endDate])

  //Today Revenue
  const fetchTodayParcelinfo = (Role, User_id) => {
    setLoading1(true)
    const data = {
      role: Role,
      user_id: User_id,
      assigned_users: assigned_users,
    }
    const URL = `${apiURl}/fetchTodayParcelDetails`
    axios
      .post(URL, data)
      .then(response => {
        if (response.data.status === "success") {
          const Data = filterDataByDateRange(
            response.data.parcelDetails,
            startDate,
            endDate
          )
          setLoading1(false)

          let TotalParcelAmount = 0
          let TotalDocAmount = 0
          let ParcelCviAmount = 0
          let DocCviAmount = 0
          let riderCharges = 0
          Data.forEach(item => {
            TotalParcelAmount += parseFloat(item.total_price) || 0
            TotalDocAmount += parseFloat(item.docs_total_price) || 0
            ParcelCviAmount += parseFloat(item.parcel_price) || 0
            DocCviAmount += parseFloat(item.doc_cvi_amount) || 0
            riderCharges +=
              item.rider_charges && parseFloat(item.rider_charges) > 0
                ? parseFloat(item.rider_charges)
                : 0
          })

          const TotalAmount = TotalParcelAmount + TotalDocAmount
          const TotalCviAmount = ParcelCviAmount + DocCviAmount
          const CviPercent = TotalCviAmount * 0.025
          const ForGST = TotalAmount - CviPercent - riderCharges
          const GSTAmount = ForGST * 0.15
          const TotalAmountWithGST = TotalAmount + GSTAmount
          setTodayRevenue(TotalAmountWithGST)
        } else {
          console.error("Failed to fetch users:", response.data.message)
          setLoading1(true)
        }
      })
      .catch(error => {
        console.error("Error fetching users:", error)
        setLoading1(true)
      })
  }

  useEffect(() => {
    fetchParcelCounts()
    fetchTodayParcelCounts()
    fetchRequestCounts()
    date()
    fetchParcelinfo(role, user_id)
    fetchTodayParcelinfo(role, user_id)
  }, [role, user_id])

  //meta title
  document.title = "Dashboard"

  return (
    <React.Fragment>
      <div className="page-content dashboard-modern mb-2">
        <Container fluid className="p-4">
          {/* Modern Header with Gradient */}
          <div className="dashboard-header mb-4 mt-4">
            <div className="header-content">
              <div>
                <h1 className="dashboard-title mb-2">
                  Welcome Back,{" "}
                  <span className="text-gradient">{full_name}</span>
                </h1>
                <p className="dashboard-subtitle mb-0">
                  Here's what's happening with your business today
                </p>
              </div>
              <div className="header-actions">
                <div className="date-badge">
                  <i className="bx bx-calendar me-2"></i>
                  {new Date().toLocaleDateString("en-US", {
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </div>
              </div>
            </div>
          </div>

          {/* Revenue Report - Modern Design */}
          {role === "admin" ? (
            <Card className="revenue-card mb-4">
              <CardBody className="p-4">
                <div className="section-header mb-4">
                  <div className="d-flex align-items-center">
                    <div className="icon-wrapper revenue-icon me-3">
                      <i className="bx bx-line-chart"></i>
                    </div>
                    <div>
                      <h4 className="section-title mb-1">Revenue Analytics</h4>
                      <p className="section-subtitle mb-0">
                        Track your financial performance
                      </p>
                    </div>
                  </div>
                  <div className="filter-controls">
                    <div className="date-picker-wrapper">
                      <DatePicker
                        selected={startDate}
                        onChange={date => setStartDate(date)}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        className="form-control-modern"
                        placeholderText="Start Date"
                        dateFormat="dd/MM/yyyy"
                      />
                      <i className="bx bx-calendar date-icon"></i>
                    </div>
                    <span className="date-separator">—</span>
                    <div className="date-picker-wrapper">
                      <DatePicker
                        selected={endDate}
                        onChange={date => setEndDate(date)}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        className="form-control-modern"
                        placeholderText="End Date"
                        dateFormat="dd/MM/yyyy"
                      />
                      <i className="bx bx-calendar date-icon"></i>
                    </div>
                    <Button
                      className="btn-modern-reset"
                      onClick={() => {
                        setStartDate(null)
                        setEndDate(null)
                      }}
                    >
                      <i className="bx bx-refresh me-1"></i>
                      Reset
                    </Button>
                  </div>
                </div>

                <Row className="g-4">
                  <Col lg="3" md="6">
                    <div className="stat-card stat-card-success">
                      <div className="stat-icon">
                        <i className="bx bx-trending-up"></i>
                      </div>
                      <div className="stat-content">
                        <span className="stat-label">Today's Revenue</span>
                        {loading1 ? (
                          <div className="stat-loader">
                            <Spinner size="sm" />
                          </div>
                        ) : (
                          <h3 className="stat-value">
                            {formatAmountCurrency(todayRevenue, "PKR")}
                          </h3>
                        )}
                        <div className="stat-trend positive">
                          <i className="bx bx-up-arrow-alt"></i>
                          <span>Live</span>
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Col lg="3" md="6">
                    <div className="stat-card stat-card-primary">
                      <div className="stat-icon">
                        <i className="bx bx-dollar-circle"></i>
                      </div>
                      <div className="stat-content">
                        <span className="stat-label">Total Revenue</span>
                        {loading ? (
                          <div className="stat-loader">
                            <Spinner size="sm" />
                          </div>
                        ) : (
                          <h3 className="stat-value">
                            {formatAmountCurrency(totalRevenue, "PKR")}
                          </h3>
                        )}
                        <div className="stat-trend neutral">
                          <i className="bx bx-stats"></i>
                          <span>All Time</span>
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Col lg="3" md="6">
                    <div className="stat-card stat-card-warning">
                      <div className="stat-icon">
                        <i className="bx bx-receipt"></i>
                      </div>
                      <div className="stat-content">
                        <span className="stat-label">GST Amount (15%)</span>
                        {loading ? (
                          <div className="stat-loader">
                            <Spinner size="sm" />
                          </div>
                        ) : (
                          <h3 className="stat-value">
                            {formatAmountCurrency(gstAmount, "PKR")}
                          </h3>
                        )}
                        <div className="stat-trend neutral">
                          <i className="bx bx-info-circle"></i>
                          <span>Tax</span>
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Col lg="3" md="6">
                    <div className="stat-card stat-card-info">
                      <div className="stat-icon">
                        <i className="bx bx-file"></i>
                      </div>
                      <div className="stat-content">
                        <span className="stat-label">Document Charges</span>
                        {loading ? (
                          <div className="stat-loader">
                            <Spinner size="sm" />
                          </div>
                        ) : (
                          <h3 className="stat-value">
                            {formatAmountCurrency(DocumentChargesAmount, "PKR")}
                          </h3>
                        )}
                        <div className="stat-trend neutral">
                          <i className="bx bx-purchase-tag"></i>
                          <span>Fees</span>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          ) : (
            <Card className="revenue-card mb-4">
              <CardBody className="p-4">
                <div className="section-header mb-4">
                  <div className="d-flex align-items-center">
                    <div className="icon-wrapper revenue-icon me-3">
                      <i className="bx bx-line-chart"></i>
                    </div>
                    <div>
                      <h4 className="section-title mb-1">Revenue Overview</h4>
                      <p className="section-subtitle mb-0">
                        Report for {todayDate}
                      </p>
                    </div>
                  </div>
                </div>

                <Row className="g-4">
                  <Col md="4">
                    <div className="stat-card stat-card-primary">
                      <div className="stat-icon">
                        <i className="bx bx-trending-up"></i>
                      </div>
                      <div className="stat-content">
                        <span className="stat-label">Today's Revenue</span>
                        {loading1 ? (
                          <div className="stat-loader">
                            <Spinner size="sm" />
                          </div>
                        ) : (
                          <h3 className="stat-value">
                            {formatAmountCurrency(todayRevenue, "PKR")}
                          </h3>
                        )}
                      </div>
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="stat-card stat-card-primary">
                      <div className="stat-icon">
                        <i className="bx bx-dollar-circle"></i>
                      </div>
                      <div className="stat-content">
                        <span className="stat-label">Total Revenue</span>
                        {loading ? (
                          <div className="stat-loader">
                            <Spinner size="sm" />
                          </div>
                        ) : (
                          <h3 className="stat-value">
                            {formatAmountCurrency(totalRevenue, "PKR")}
                          </h3>
                        )}
                      </div>
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="stat-card stat-card-primary">
                      <div className="stat-icon">
                        <i className="bx bx-receipt"></i>
                      </div>
                      <div className="stat-content">
                        <span className="stat-label">GST (15%)</span>
                        {loading ? (
                          <div className="stat-loader">
                            <Spinner size="sm" />
                          </div>
                        ) : (
                          <h3 className="stat-value">
                            {formatAmountCurrency(gstAmount, "PKR")}
                          </h3>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          )}

          {/* Online Requests Section */}
          <Card className="requests-card mb-4">
            <CardBody className="p-4">
              <div className="section-header mb-4">
                <div className="d-flex align-items-center">
                  <div className="icon-wrapper requests-icon me-3">
                    <i className="bx bx-list-ul"></i>
                  </div>
                  <div>
                    <h4 className="section-title mb-1">
                      Online Requests
                      <Badge className="ms-3 count-badge">
                        {requestCounts.allRequest}
                      </Badge>
                    </h4>
                    <p className="section-subtitle mb-0">
                      Manage customer requests efficiently
                    </p>
                  </div>
                </div>
              </div>

              <Row className="g-4">
                {role === "admin" && (
                  <Col lg="3" md="6">
                    <Link to="/all_requests#new" className="card-link">
                      <div className="status-card status-card-today">
                        <div className="status-header">
                          <span className="status-label">Today's Requests</span>
                          <i className="bx bx-calendar-event status-icon"></i>
                        </div>
                        <h2 className="status-count">
                          {requestCounts.todayDateRequest}
                        </h2>
                        <div className="status-footer">
                          <span className="status-tag">Current Day</span>
                        </div>
                      </div>
                    </Link>
                  </Col>
                )}

                <Col lg={role === "admin" ? "3" : "4"} md="6">
                  <Link to="/all_requests#new" className="card-link">
                    <div className="status-card status-card-new">
                      <div className="status-header">
                        <span className="status-label">New Requests</span>
                        <i className="bx bx-bell status-icon"></i>
                      </div>
                      <h2 className="status-count">
                        {requestCounts.newRequest}
                      </h2>
                      <div className="status-footer">
                        <span className="status-tag">Pending Review</span>
                      </div>
                    </div>
                  </Link>
                </Col>

                {role === "admin" && (
                  <>
                    <Col lg="3" md="6">
                      <Link to="/all_requests#approved" className="card-link">
                        <div className="status-card status-card-approved">
                          <div className="status-header">
                            <span className="status-label">Approved</span>
                            <i className="bx bx-check-circle status-icon"></i>
                          </div>
                          <h2 className="status-count">
                            {requestCounts.approvedRequest}
                          </h2>
                          <div className="status-footer">
                            <span className="status-tag">Completed</span>
                          </div>
                        </div>
                      </Link>
                    </Col>

                    <Col lg="3" md="6">
                      <div className="status-card status-card-mixed">
                        <div className="status-header">
                          <span className="status-label">
                            Declined / Resubmit
                          </span>
                          <i className="bx bx-error-circle status-icon"></i>
                        </div>
                        <div className="split-count">
                          <Link
                            to="/all_requests#declined"
                            className="split-item declined"
                          >
                            <span className="split-label">Declined</span>
                            <h3 className="split-value">
                              {requestCounts.declineRequest}
                            </h3>
                          </Link>
                          <div className="split-divider"></div>
                          <Link
                            to="/all_requests#resubmitted"
                            className="split-item resubmit"
                          >
                            <span className="split-label">Resubmit</span>
                            <h3 className="split-value">
                              {requestCounts.resubmitRequest}
                            </h3>
                          </Link>
                        </div>
                      </div>
                    </Col>
                  </>
                )}
              </Row>
            </CardBody>
          </Card>

          {/* Courier Section */}
          <Card className="courier-card">
            <CardBody className="p-4">
              <div className="section-header mb-4">
                <div className="d-flex align-items-center">
                  <div className="icon-wrapper courier-icon me-3">
                    <i className="bx bx-package"></i>
                  </div>
                  <div>
                    <h4 className="section-title mb-1">
                      Courier Management
                      <Badge className="ms-3 count-badge">
                        {parcelCounts.allParcel}
                      </Badge>
                    </h4>
                    <p className="section-subtitle mb-0">
                      Track all your shipments in real-time
                    </p>
                  </div>
                </div>
              </div>

              <Row className="g-4">
                <Col lg="3" md="6">
                  <Link to="/today_book" className="card-link">
                    <div className="status-card status-card-today-parcel">
                      <div className="status-header">
                        <span className="status-label">Today's Bookings</span>
                        <i className="bx bx-calendar-plus status-icon"></i>
                      </div>
                      <h2 className="status-count">{todayParcel}</h2>
                      <div className="status-footer">
                        <span className="status-tag">New Today</span>
                      </div>
                    </div>
                  </Link>
                </Col>

                <Col lg="3" md="6">
                  <Link to="/parcel_detail/new" className="card-link">
                    <div className="status-card status-card-new-parcel">
                      <div className="status-header">
                        <span className="status-label">New Couriers</span>
                        <i className="bx bx-box status-icon"></i>
                      </div>
                      <h2 className="status-count">
                        {parcelCounts.newParcelCount}
                      </h2>
                      <div className="status-footer">
                        <span className="status-tag">Ready to Process</span>
                      </div>
                    </div>
                  </Link>
                </Col>

                <Col lg="3" md="6">
                  <Link to="/parcel_detail/in-progress" className="card-link">
                    <div className="status-card status-card-progress">
                      <div className="status-header">
                        <span className="status-label">In Progress</span>
                        <i className="bx bx-run status-icon"></i>
                      </div>
                      <h2 className="status-count">
                        {parcelCounts.inProgressParcelCount}
                      </h2>
                      <div className="status-footer">
                        <span className="status-tag">In Transit</span>
                      </div>
                    </div>
                  </Link>
                </Col>

                <Col lg="3" md="6">
                  <Link to="/parcel_detail/delivered" className="card-link">
                    <div className="status-card status-card-delivered">
                      <div className="status-header">
                        <span className="status-label">Delivered</span>
                        <i className="bx bx-check-shield status-icon"></i>
                      </div>
                      <h2 className="status-count">
                        {parcelCounts.deliveredParcelCount}
                      </h2>
                      <div className="status-footer">
                        <span className="status-tag">Completed</span>
                      </div>
                    </div>
                  </Link>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>

        {/* Modern Custom Styles */}
        <style>{`
          /* ===== DASHBOARD MODERN STYLES ===== */
          .dashboard-modern {
            background: linear-gradient(30deg, #f5f7fa 0%, #eef2faff 100%);
            min-height: 100vh;
            padding: 2rem 0;
          }

          /* Header Styles */
          .dashboard-header {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            border-radius: 20px;
            padding: 2rem;
            box-shadow: 0 10px 40px rgba(102, 126, 234, 0.3);
            position: relative;
            overflow: hidden;
          }

          .dashboard-header::before {
            content: '';
            position: absolute;
            top: -50%;
            right: -10%;
            width: 300px;
            height: 300px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 50%;
          }

          .header-content {
            position: relative;
            z-index: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            gap: 1.5rem;
          }

          .dashboard-title {
            font-size: 2rem;
            font-weight: 700;
            color: #ffffff;
            margin: 0;
            letter-spacing: -0.5px;
          }

          .text-gradient {
            background: linear-gradient(135deg, #ffeaa7 0%, #fdcb6e 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }

          .dashboard-subtitle {
            color: rgba(255, 255, 255, 0.9);
            font-size: 1rem;
            font-weight: 400;
          }

          .date-badge {
            background: rgba(255, 255, 255, 0.2);
            backdrop-filter: blur(10px);
            padding: 0.75rem 1.5rem;
            border-radius: 50px;
            color: #ffffff;
            font-weight: 500;
            font-size: 0.9rem;
            display: flex;
            align-items: center;
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
          }

          /* Card Styles */
          .revenue-card, .requests-card, .courier-card {
            border: none;
            border-radius: 20px;
            box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
            background: #ffffff;
            transition: transform 0.3s ease, box-shadow 0.3s ease;
            overflow: hidden;
          }

          .revenue-card:hover, .requests-card:hover, .courier-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 15px 50px rgba(0, 0, 0, 0.12);
          }

          /* Section Header */
          .section-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            gap: 1.5rem;
            padding-bottom: 1.5rem;
            border-bottom: 2px solid #f0f2f5;
          }

          .icon-wrapper {
            width: 60px;
            height: 60px;
            border-radius: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.8rem;
            position: relative;
            overflow: hidden;
          }

          .icon-wrapper::before {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            background: inherit;
            opacity: 0.2;
            filter: blur(10px);
          }

          .revenue-icon {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: #ffffff;
          }

          .requests-icon {
            background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
            color: #ffffff;
          }

          .courier-icon {
            background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
            color: #ffffff;
          }

          .section-title {
            font-size: 1.5rem;
            font-weight: 700;
            color: #2d3436;
            margin: 0;
            display: flex;
            align-items: center;
          }

          .section-subtitle {
            color: #636e72;
            font-size: 0.9rem;
            font-weight: 400;
          }

          .count-badge {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: #ffffff;
            padding: 0.4rem 1rem;
            border-radius: 50px;
            font-weight: 600;
            font-size: 0.85rem;
            box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
          }

          /* Filter Controls */
          .filter-controls {
            display: flex;
            align-items: center;
            gap: 0.75rem;
            flex-wrap: wrap;
          }

          .date-picker-wrapper {
            position: relative;
          }

          .form-control-modern {
            border: 2px solid #e8edf2;
            border-radius: 12px;
            padding: 0.75rem 1rem 0.75rem 2.75rem;
            font-size: 0.9rem;
            font-weight: 500;
            color: #2d3436;
            background: #ffffff;
            transition: all 0.3s ease;
            min-width: 160px;
          }

          .form-control-modern:focus {
            border-color: #667eea;
            box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
            outline: none;
          }

          .date-icon {
            position: absolute;
            left: 1rem;
            top: 50%;
            transform: translateY(-50%);
            color: #636e72;
            font-size: 1.1rem;
            pointer-events: none;
          }

          .date-separator {
            color: #b2bec3;
            font-weight: 500;
            font-size: 1.2rem;
          }

          .btn-modern-reset {
            border: 2px solid #dfe6e9;
            border-radius: 12px;
            padding: 0.75rem 1.5rem;
            font-size: 0.9rem;
            font-weight: 600;
            color: #2d3436;
            background: #ffffff;
            transition: all 0.3s ease;
          }

          .btn-modern-reset:hover {
            background: #f8f9fa;
            border-color: #b2bec3;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          }

          /* Stat Cards */
          .stat-card {
            background: #ffffff;
            border-radius: 16px;
            padding: 1.75rem;
            position: relative;
            overflow: hidden;
            transition: all 0.3s ease;
            border: 2px solid transparent;
            height: 100%;
          }

          .stat-card::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 4px;
            height: 100%;
            transition: width 0.3s ease;
          }

          .stat-card:hover {
            transform: translateY(-8px);
            box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);
          }

          

          .stat-card-success::before {
            background: linear-gradient(135deg, #00b894 0%, #00cec9 100%);
          }

          .stat-card-primary::before {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          }

          .stat-card-warning::before {
            background: linear-gradient(135deg, #fdcb6e 0%, #e17055 100%);
          }

          .stat-card-info::before {
            background: linear-gradient(135deg, #74b9ff 0%, #0984e3 100%);
          }

          .stat-icon {
            width: 50px;
            height: 50px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.5rem;
            margin-bottom: 1rem;
            position: relative;
          }

          .stat-card-success .stat-icon {
            background: linear-gradient(135deg, #00b894 0%, #00cec9 100%);
            color: #ffffff;
            box-shadow: 0 8px 20px rgba(0, 184, 148, 0.3);
          }

          .stat-card-primary .stat-icon {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: #ffffff;
            box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
          }

          .stat-card-warning .stat-icon {
            background: linear-gradient(135deg, #fdcb6e 0%, #e17055 100%);
            color: #ffffff;
            box-shadow: 0 8px 20px rgba(253, 203, 110, 0.3);
          }

          .stat-card-info .stat-icon {
            background: linear-gradient(135deg, #74b9ff 0%, #0984e3 100%);
            color: #ffffff;
            box-shadow: 0 8px 20px rgba(116, 185, 255, 0.3);
          }

          .stat-content {
            flex: 1;
          }

          .stat-label {
            display: block;
            font-size: 0.85rem;
            font-weight: 600;
            color: #636e72;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            margin-bottom: 0.5rem;
          }

          .stat-value {
            font-size: 1.75rem;
            font-weight: 700;
            color: #2d3436;
            margin: 0.5rem 0;
            line-height: 1.2;
          }

          .stat-trend {
            display: inline-flex;
            align-items: center;
            gap: 0.3rem;
            padding: 0.3rem 0.75rem;
            border-radius: 20px;
            font-size: 0.75rem;
            font-weight: 600;
            margin-top: 0.75rem;
          }

          .stat-trend.positive {
            background: rgba(0, 184, 148, 0.1);
            color: #00b894;
          }

          .stat-trend.neutral {
            background: rgba(99, 110, 114, 0.1);
            color: #636e72;
          }

          .stat-loader {
            padding: 1rem 0;
          }

          /* Status Cards */
          .card-link {
            text-decoration: none;
            display: block;
            height: 100%;
          }

          .status-card {
            background: #ffffff;
            border-radius: 16px;
            padding: 1.75rem;
            height: 100%;
            transition: all 0.3s ease;
            border: 2px solid #f0f2f5;
            position: relative;
            overflow: hidden;
          }

          .status-card::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 4px;
            transition: height 0.3s ease;
          }

          .status-card:hover {
            transform: translateY(-8px);
            box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);
            border-color: transparent;
          }

          .status-card-today::before {
            background: linear-gradient(135deg, #ffeaa7 0%, #fdcb6e 100%);
          }

          .status-card-new::before {
            background: linear-gradient(135deg, #fdcb6e 0%, #e17055 100%);
          }

          .status-card-approved::before {
            background: linear-gradient(135deg, #00b894 0%, #00cec9 100%);
          }

          .status-card-mixed::before {
            background: linear-gradient(135deg, #d63031 0%, #fdcb6e 100%);
          }

          .status-card-today-parcel::before {
            background: linear-gradient(135deg, #a29bfe 0%, #6c5ce7 100%);
          }

          .status-card-new-parcel::before {
            background: linear-gradient(135deg, #74b9ff 0%, #0984e3 100%);
          }

          .status-card-progress::before {
            background: linear-gradient(135deg, #fdcb6e 0%, #e17055 100%);
          }

          .status-card-delivered::before {
            background: linear-gradient(135deg, #00b894 0%, #00cec9 100%);
          }

          .status-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 1.5rem;
          }

          .status-label {
            font-size: 0.85rem;
            font-weight: 600;
            color: #636e72;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }

          .status-icon {
            font-size: 1.5rem;
            color: #b2bec3;
            transition: all 0.3s ease;
          }

          .status-card:hover .status-icon {
            transform: scale(1.2) rotate(10deg);
            color: #667eea;
          }

          .status-count {
            font-size: 2.5rem;
            font-weight: 700;
            color: #2d3436;
            margin: 0.75rem 0;
            line-height: 1;
          }

          .status-footer {
            margin-top: 1rem;
          }

          .status-tag {
            display: inline-block;
            padding: 0.4rem 1rem;
            background: #f0f2f5;
            color: #636e72;
            font-size: 0.75rem;
            font-weight: 600;
            border-radius: 20px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }

          /* Split Count for Mixed Status */
          .split-count {
            display: flex;
            gap: 1rem;
            margin-top: 1rem;
          }

          .split-item {
            flex: 1;
            text-decoration: none;
            padding: 1rem;
            border-radius: 12px;
            transition: all 0.3s ease;
            text-align: center;
          }

          .split-item.declined {
            background: rgba(214, 48, 49, 0.05);
          }

          .split-item.declined:hover {
            background: rgba(214, 48, 49, 0.1);
            transform: scale(1.05);
          }

          .split-item.resubmit {
            background: rgba(253, 203, 110, 0.05);
          }

          .split-item.resubmit:hover {
            background: rgba(253, 203, 110, 0.1);
            transform: scale(1.05);
          }

          .split-label {
            display: block;
            font-size: 0.75rem;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            margin-bottom: 0.5rem;
          }

          .split-item.declined .split-label {
            color: #d63031;
          }

          .split-item.resubmit .split-label {
            color: #fdcb6e;
          }

          .split-value {
            font-size: 1.75rem;
            font-weight: 700;
            margin: 0;
          }

          .split-item.declined .split-value {
            color: #d63031;
          }

          .split-item.resubmit .split-value {
            color: #e17055;
          }

          .split-divider {
            width: 2px;
            background: #dfe6e9;
            margin: 0.5rem 0;
          }

          /* Responsive Design */
          @media (max-width: 1200px) {
            .filter-controls {
              width: 100%;
              justify-content: flex-start;
            }
          }

          @media (max-width: 768px) {
            .dashboard-modern {
              padding: 1rem 0;
            }

            .dashboard-header {
              padding: 1.5rem;
              border-radius: 16px;
            }

            .header-content {
              flex-direction: column;
              align-items: flex-start;
            }

            .dashboard-title {
              font-size: 1.5rem;
            }

            .date-badge {
              width: 100%;
              justify-content: center;
            }

            .section-header {
              flex-direction: column;
              align-items: flex-start;
            }

            .filter-controls {
              width: 100%;
            }

            .form-control-modern {
              width: 100%;
            }

            .stat-value {
              font-size: 1.5rem;
            }

            .status-count {
              font-size: 2rem;
            }

            .icon-wrapper {
              width: 50px;
              height: 50px;
              font-size: 1.5rem;
            }
          }

          @media (max-width: 576px) {
            .dashboard-title {
              font-size: 1.25rem;
            }

            .section-title {
              font-size: 1.25rem;
            }

            .stat-value {
              font-size: 1.25rem;
            }

            .status-count {
              font-size: 1.75rem;
            }

            .split-count {
              flex-direction: column;
              gap: 0.75rem;
            }

            .split-divider {
              width: 100%;
              height: 2px;
            }
          }

          /* Animation */
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .revenue-card, .requests-card, .courier-card {
            animation: fadeInUp 0.6s ease-out forwards;
          }

          .requests-card {
            animation-delay: 0.1s;
          }

          .courier-card {
            animation-delay: 0.2s;
          }

          /* Loading State */
          .spinner-border {
            color: #667eea !important;
          }

          /* Print Styles */
          @media print {
            .dashboard-modern {
              background: white;
            }

            .filter-controls, .header-actions {
              display: none;
            }

            .stat-card, .status-card {
              break-inside: avoid;
              box-shadow: none;
              border: 1px solid #ddd;
            }
          }
        `}</style>
      </div>
    </React.Fragment>
  )
}

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
}

export default withTranslation()(Dashboard)
